import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { dashboardRoutesConfig } from 'domains/dashboard/routes';
import { usePartnerClientStatus } from 'domains/jwtToken/hooks/usePartnerClientStatus';

export const useRedirectForPartners = () => {
  const { push } = useHistory();

  const { isPartnerClient, isPartnerStatusLoading } = usePartnerClientStatus();

  useEffect(() => {
    if (!isPartnerStatusLoading && isPartnerClient) {
      push(dashboardRoutesConfig.dashboard.path);
    }
  }, [isPartnerClient, isPartnerStatusLoading, push]);
};
